/*
  Date Picker
*/

import React from 'react';

// Antd
import { Form } from 'antd';

import TimePicker from './TimePickerComponent';

// import { CaretDownOutlined } from '@ant-design/icons';

// Localization
import LOCALIZATION from '../../../../services/LocalizationService';

// import { SPACE_VALIDATIOR } from '../../../../constants/Patterns';

// Style
// import './style.scss';s

function Picker({ 
  name, label, placeholder, 
  readOnly, defaultValue, format,
  onChange, disabled, required,
  onBlur, validator, validateTrigger,
  disabledDate, notwrapInForm, type
}) {

  // Rules
  let rules = [
    { required: required, message: LOCALIZATION.REQUIRED },
  ];

  // Custom Validations
  !!validator && rules.push( {validator} );

  const TimePickerInput = (
    <TimePicker 
      placeholder={ placeholder || label } 
      onChange={ onChange || null } 
      defaultValue={ defaultValue }
      disabled={ disabled }
      onBlur={ onBlur }
      picker={ type }
      readOnly={ readOnly }
      format={ format }
      disabledDate={ disabledDate }
    />
  );

  return(
    !!notwrapInForm?
      <>
        { TimePickerInput }
      </>:
      <Form.Item
        name={ name }
        label={ label }
        validateTrigger={ validateTrigger || 'onBlur' }
        rules={ rules }
      >
        { TimePickerInput }
      </Form.Item>

  );
}

export default Picker;